<template>
  <v-app id="inspire">
    <v-content>
      <error-block></error-block>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
            md="4"
          >
            <router-view></router-view>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import ErrorBlock from './BaseLayout/ErrorBlock.vue';

export default {
  name: 'CenterLayout',
  components: { ErrorBlock },
};
</script>

<style scoped>

</style>
